// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__1GsPH","like":"style_like__1GFiq","likesAmount":"style_likesAmount__1892I","comment":"style_comment__21qxD","share":"style_share__3Z44U"};